import {getStoreContactFlowArticleId, removeStoreContactFlowArticleId} from '../../../storage';
import {Icon, iconsMap} from '../../../../common/icons/icon.comp';
import {BaseWidgetProps} from '../../../widget-container';
import {classNames} from '../../../../common/utils';
import * as React from 'react';
import {Article, ArticleType} from '@wix/answers-api';
import {EventType} from '../../../../common/logger/event-type';
import {NavigationState} from '../../../../common/navigator';

export interface FeedbackProps {
	article: Article;
	baseConfig: BaseWidgetProps;
}

export class Feedback extends React.Component<FeedbackProps, any> {

	state = {
		ratingValue: null,
		itemWasVoted: false,
		isContactLink: false
	};

	getItemData (): boolean | null {
		try {
			const article = this.props.article;
			const state = window && window.localStorage ? localStorage.getItem(article.id + article.locale) : null;
			return (state === 'true') ? true : (state === 'false' ? false : null);
		} catch (error) {
			return null;
		}
	}

	storeItemData (state: boolean | null): void {
		try {
			if (window && window.localStorage) {
				const article = this.props.article;
				if (state === null) {
					localStorage.removeItem(article.id + article.locale);
				} else {
					localStorage.setItem(article.id + article.locale, state.toString());
				}
			}
		} catch (error) {
			// tslint:disable-next-line:no-console
			console.error(error);
		}
	}

	componentWillMount () {
		this.setState({ ratingValue: this.getItemData() });
		const contactFlowArticleId = getStoreContactFlowArticleId();
		if (this.props.baseConfig.widgetConfig.modulesConfig.ticketsEnabled) {
			if (contactFlowArticleId === this.props.article.id) {
				this.setState({ isContactLink: true });
			} else {
				removeStoreContactFlowArticleId();
			}
		}
	}

	rateArticle (newRating: boolean | null) {
		const article = this.props.article;
		if (newRating === this.state.ratingValue) {
			newRating = null;
		}
		this.storeItemData(newRating);
		this.props.baseConfig.kbApi.rateArticle(article.id, newRating, this.state.ratingValue);
		this.setState({ratingValue: newRating, itemWasVoted: true});
		if (newRating !== null) {
			this.props.baseConfig.logger.logEvent(EventType.ARTICLE_VOTE, {article, vote: newRating});
		} else {
			this.props.baseConfig.logger.logEvent(EventType.ARTICLE_UNVOTE, {article, vote: newRating});
		}
	}

	voteArticle () {
		const article = this.props.article;
		const newValue = (this.state.ratingValue) ? null : true;
		this.storeItemData(newValue);
		if (newValue) {
			this.props.baseConfig.kbApi.voteArticle(article.id);
			this.props.baseConfig.logger.logEvent(EventType.ARTICLE_VOTE, {article, vote: newValue});
		} else {
			this.props.baseConfig.kbApi.removeVoteArticle(article.id);
			this.props.baseConfig.logger.logEvent(EventType.ARTICLE_UNVOTE, {article, vote: newValue});
		}
		this.setState({ratingValue: newValue, itemWasVoted: true});
	}

	goToContact = () => {
		const article = this.props.article;
		this.props.baseConfig.logger.logEvent(EventType.ARTICLE_UNHELPFUL, {article, vote: false});
		this.props.baseConfig.widgetNavigator.goToState(NavigationState.tickets, {});
	}

	goToHelped = () => {
		const article = this.props.article;
		this.props.baseConfig.logger.logEvent(EventType.ARTICLE_HELPFUL, {article, vote: true});
		this.props.baseConfig.widgetNavigator.goToState(NavigationState.helped, {});
	}

	render () {
		const translate = this.props.baseConfig.translate;
		const ratingValue = this.state.ratingValue;

		if (this.state.isContactLink) {
			const contactFeedbackComp = (
				<div className='feedback-item'>
					<div className='rating-label'>{translate('widget-ng.article.feedback.article-type.helpful')}</div>
					<div className='rating-actions'>
						<button className='submit-button issue-solved' onClick={this.goToHelped}>
							{translate('widget-ng.contact.feedback.helpful')}
						</button>
						<button className='submit-button' onClick={this.goToContact}>
							{translate('widget-ng.contact.feedback.not-helpful')}
						</button>
					</div>
				</div>
			);
			return (<div className='feedback'>{contactFeedbackComp}</div>);
		}

		const articleFeedbackComp = (
			<div className='feedback-item'>
				<div className='rating-label'>{translate('widget-ng.article.feedback.article-type.helpful')}</div>
				<div className='rating-actions'>
					<a
						className={classNames('btn helpful', {active: ratingValue === true})}
						onClick={() => this.rateArticle(true)}
					>
						<Icon icon={iconsMap.helpful} />
						{translate('common.yes')}
					</a>
					<a
						className={classNames('btn unhelpful', {active: ratingValue === false})}
						onClick={() => this.rateArticle(false)}
					>
						<Icon icon={iconsMap.unhelpful} />
						{translate('common.no')}
					</a>
				</div>
			</div>
		);
		const knownIssueFeedbackComp = (
			<div className='feedback-item'>
				<a
					className={classNames('btn vote', {active: ratingValue === true})}
					onClick={() => this.voteArticle()}
				>
					<Icon icon={ratingValue === true ? iconsMap.checkedCircle : iconsMap.voteForExperience} />
					{translate('widget-ng.article.feedback.known-issue-type.vote')}
				</a>
			</div>
		);
		const featureRequestFeedbackComp = (
			<div className='feedback-item'>
				<a
					className={classNames('btn vote', {active: ratingValue === true})}
					onClick={() => this.voteArticle()}
				>
					<Icon icon={ratingValue === true ? iconsMap.checkedCircle : iconsMap.voteForFeature} />
					{translate('widget-ng.article.feedback.feature-request.vote')}
				</a>
			</div>
		);

		const thanksMsgKey = this.state.ratingValue ? 'widget-ng.article.feedback.yes.feedback'
			: 'widget-ng.article.feedback.no.feedback';
		const thanksMsg = (
			<div className='feedback-thanks'>{translate(thanksMsgKey)}</div>
		);

		const articleType = this.props.article.type;

		return (
			<div className='feedback'>
				{articleType === ArticleType.ARTICLE ? articleFeedbackComp : null}
				{articleType === ArticleType.KNOWN_ISSUE ? knownIssueFeedbackComp : null}
				{articleType === ArticleType.FEATURE_REQUEST ? featureRequestFeedbackComp : null}
				{this.state.itemWasVoted ? thanksMsg : null}
			</div>
		);
	}
}
